import { render, staticRenderFns } from "./AddressDetails.component.vue?vue&type=template&id=1977a77e&"
import script from "./AddressDetails.component.vue?vue&type=script&lang=ts&"
export * from "./AddressDetails.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports